/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionIssuerCimdClient,
  UserSessionIssuerCimdClient$inboundSchema,
} from "./usersessionissuercimdclient.js";

/**
 * Result of allowing a CIMD document URL. Reachability is not reported here — call verifyURL for that.
 */
export type CreateUserSessionIssuerCimdClientResult = {
  /**
   * A CIMD document URL explicitly allowed on a user_session_issuer, additive to the preset catalog.
   */
  client: UserSessionIssuerCimdClient;
};

/** @internal */
export const CreateUserSessionIssuerCimdClientResult$inboundSchema:
  z.ZodMiniType<CreateUserSessionIssuerCimdClientResult, unknown> = z.object({
    client: UserSessionIssuerCimdClient$inboundSchema,
  });

export function createUserSessionIssuerCimdClientResultFromJSON(
  jsonString: string,
): SafeParseResult<
  CreateUserSessionIssuerCimdClientResult,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      CreateUserSessionIssuerCimdClientResult$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'CreateUserSessionIssuerCimdClientResult' from JSON`,
  );
}
